import React from "react";

function GameOverScreen({ score, onRestart, onExit }) {
  return (
    <div style={overlayStyle}>
      <div style={modalStyle}>
        <h1 style={titleStyle}>Game Over</h1>
        <p style={scoreStyle}>Your Score: <span>{score}</span></p>
        <div style={buttonContainerStyle}>
          <button style={restartButtonStyle} onClick={onRestart}>Restart Game</button>
          <button style={exitButtonStyle} onClick={onExit}>Exit</button>
        </div>
      </div>
    </div>
  );
}

// Styles for the overlay and modal
const overlayStyle = {
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  backgroundColor: "rgba(0, 0, 0, 0.7)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 1000,
};

const modalStyle = {
  backgroundColor: "white",
  padding: "40px",
  borderRadius: "12px",
  textAlign: "center",
  maxWidth: "500px", // Increased width for more emphasis
  width: "90%",
  boxShadow: "0 8px 16px rgba(0, 0, 0, 0.3)", // Subtle shadow for depth
  color: "black",
};

const titleStyle = {
  fontSize: "36px",
  fontWeight: "bold",
  color: "#FF6347", // Highlighted title color
  marginBottom: "20px",
};

const scoreStyle = {
  fontSize: "20px",
  marginBottom: "30px",
};

const buttonContainerStyle = {
  display: "flex",
  gap: "20px",
  justifyContent: "center",
};

const restartButtonStyle = {
  padding: "12px 24px",
  fontSize: "16px",
  backgroundColor: "#4CAF50",
  color: "white",
  border: "none",
  borderRadius: "5px",
  cursor: "pointer",
  transition: "background-color 0.3s ease",
};

const exitButtonStyle = {
  padding: "12px 24px",
  fontSize: "16px",
  backgroundColor: "#FF6347",
  color: "white",
  border: "none",
  borderRadius: "5px",
  cursor: "pointer",
  transition: "background-color 0.3s ease",
};

const buttonHover = {
  restartButton: { backgroundColor: "#45a049" },
  exitButton: { backgroundColor: "#e05343" },
};

// Adding hover effects for buttons
restartButtonStyle[":hover"] = buttonHover.restartButton;
exitButtonStyle[":hover"] = buttonHover.exitButton;

export default GameOverScreen;

